import styled from 'styled-components';
import MuiAlert from '@material-ui/lab/Alert';
import { Colors } from 'modules/ui';

export const StyledAlert = styled(MuiAlert)`
  &.MuiAlert-filledWarning {
    background-color: ${Colors.Magenta};
  }
`;
